import script from "./BannerCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerCard.vue?vue&type=script&setup=true&lang=js"

import "./BannerCard.vue?vue&type=style&index=0&id=4e1a0e94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e1a0e94"]])

export default __exports__